document.querySelectorAll('.whatsapp').forEach((whatsappElement) => {
  whatsappElement.addEventListener('click', function (e) {
    var iframe = document.getElementById('toggle-iframe');

    if (iframe && iframe.contentWindow) {
      var iframeDocument = iframe.contentWindow.document;

      var button = iframeDocument.querySelector('button');
      if (button) {
        button.click();
      }
    }
  });
});
